export const COLOR_PRIMARY = '#255968';
